import styled from 'styled-components';

export const Container = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;

  border: none;
  border-radius: var(--radius-md);
  font-weight: 700;
  font-family: var(--font-sans);
  color: var(--primary-foreground);
  background: var(--primary);
  font-size: 0.95rem;
  line-height: 1.5rem;
  height: 48px;
  padding: 0.5rem 1.75rem;

  transition: background 0.15s, box-shadow 0.15s;

  &:disabled {
    cursor: not-allowed;
    background: var(--primary-soft);
  }

  &:hover:not(:disabled) {
    background: var(--primary-hover);
  }

  &:focus-visible {
    box-shadow: 0 0 0 3px rgba(255, 188, 3, 0.4);
  }

  svg {
    margin-left: 0.5rem;
  }
`;
export const Loading = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid #fff;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
  margin-left: 0.5rem;

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
